import styled from 'styled-components';

import imoveisImg from '../../../public/svg/logo-classi-imoveis.svg';
import bgImage from '../../../public/imgs/capa-poly-bg.jpg';

export const CarrosselContainer = styled.div`
    width: ${(props) => (props.imageLength === 1 ? '35%' : '100%')};
    height: 320px;

    @media (max-width: 1024px) {
        height: 40vw;
        margin: auto;
        width: ${(props) => (props.imageLength === 1 ? '50%' : '100%')};
    }

    @media (max-width: 425px) {
        height: 95vw;
        margin: auto;
        width: 100%;
    }

    .swiper {
        width: 100%;
        height: 100%;
    }

    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;
        /* Center slide text vertically */
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .swiper-button-prev {
        display: ${(props) => (props.imageLength > 3 ? 'block' : 'none')};
        position: absolute;
        z-index: 2;
        width: 50px;
        height: auto;
        cursor: pointer;
        color: rgba(255, 255, 255, 1);
    }

    .swiper-button-next {
        display: ${(props) => (props.imageLength > 3 ? 'block' : 'none')};
        position: absolute;
        z-index: 2;
        width: -50px;
        height: auto;
        cursor: pointer;
        color: rgba(255, 255, 255, 1);
    }

    .swiper-button-prev::after,
    .swiper-button-next::after {
        font-size: 30px;
    }
`;

export const ContainerImagem = styled.div`
    align-content: center;
    width: 100%;
    height: 100%;
`;

export const NoImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;

    background: url(${imoveisImg}) no-repeat 50%, url(${bgImage}) no-repeat 57%;
`;
